
const monthDiff = (d1, d2) => {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}

const showHalfRating = (titleNumber) => {
    return  titleNumber % 2 === 0
}

const getLetterSum = (rawTitle = "") => {
    let productTitle = rawTitle.toLowerCase().trim().replace(/\s/g, '');
    let total = 0;
    for (let index in productTitle) {
        let letter = productTitle[index];
        let number = letter.charCodeAt(0) - 96;
        total += number;
    }
    // reduce to a single digit for stability
    while (total >= 10) {
        let digits = total.toString().split('');
        let realDigits = digits.map(Number);
        total = 0;
        for (let i in realDigits) {
            total += realDigits[i];
        }
    }
    return total < 1 ? 1 : total;
};

const computeRatingCount = (productTitle = "", publishedAtRaw = "", now = new Date()) => {
    const baseSeed = getLetterSum(productTitle);
    const shouldShowHalfRating = showHalfRating(baseSeed);

    const publishedAt = new Date(publishedAtRaw);
    if (isNaN(publishedAt.getTime())) {
        return { rating: baseSeed, shouldShowHalfRating, isPlural: baseSeed > 1 };
    }

    const msPerDay = 24 * 60 * 60 * 1000;
    const ageDays = (now - publishedAt) / msPerDay;

    let rating = baseSeed;
    if (ageDays < 1) {
        rating = 1;
    } else if (ageDays < 7) {
        rating = Math.min(9, baseSeed + Math.floor(ageDays));
    } else {
        const ageMonths = Math.max(1, monthDiff(publishedAt, now));
        const growthScale = 1700 / Math.pow(60, 1.5); // anchor: ~1700 at ~5 years (60 months)
        rating = Math.round(baseSeed + growthScale * Math.pow(ageMonths, 1.5));
    }

    rating = isNaN(rating) ? 1 : rating;
    return { rating, shouldShowHalfRating, isPlural: rating > 1 };
};

const ratingDomContentLoaded = () => {

    const dataset = document.getElementById('rating-data').dataset

    const productTitle = dataset.productTitle || "";
    const publishedAt = dataset.publishedAt;

    const { rating, shouldShowHalfRating, isPlural } = computeRatingCount(productTitle, publishedAt, new Date());

    const ratingCount = document.getElementById('ratingCount')
    ratingCount.textContent = `${rating}`;

    const ratingTextSingular = document.getElementById('rating_text_singular');
    ratingTextSingular.className = isPlural ? "rating_text_hidden" : "";
    const ratingTextPlural = document.getElementById('rating_text_plural')
    ratingTextPlural.className = isPlural ? "" : "rating_text_hidden";

    const star5 = document.getElementById('star5');
    star5.className = shouldShowHalfRating ? "star half" : "star full"
}

window.addEventListener('DOMContentLoaded', ratingDomContentLoaded);

// Expose helpers for local testing without affecting theme execution
if (typeof module !== 'undefined') {
  module.exports = {
    monthDiff,
    showHalfRating,
    getLetterSum,
    computeRatingCount,
    ratingDomContentLoaded
  };
}
